import type { LayoutCtx } from "./_shared";
import { PhotoBleedLayout } from "./photo-bleed";
import { NoirGoldLayout } from "./noir-gold";
import { WatercolorLayout } from "./watercolor";
import { ArchPhotoLayout } from "./arch-photo";
import { ModernistLayout } from "./modernist";
import { PlayfulLayout } from "./playful";
import { SoftPastelLayout } from "./soft-pastel";
import { CorporateGridLayout } from "./corporate-grid";
import { MemorialFrameLayout } from "./memorial-frame";
// 10 layouts (round 2)
import { MiniatureLayout } from "./miniature";
import { CoastalLayout } from "./coastal";
import { MilestoneLayout } from "./milestone";
import { RoseGoldLayout } from "./rose-gold";
import { SuzaniBurstLayout } from "./suzani-burst";
import { ScrollAcademicLayout } from "./scroll-academic";
import { ChampagneLayout } from "./champagne";
import { NeonTechLayout } from "./neon-tech";
import { GeometricMosaicLayout } from "./geometric-mosaic";
import { HospitalityLayout } from "./hospitality";
// 10 layouts (round 3)
import { CorpAnniversaryLayout } from "./corp-anniversary";
import { RetailOpeningLayout } from "./retail-opening";
import { ConfTracksLayout } from "./conf-tracks";
import { MasterclassLayout } from "./masterclass";
import { CharityElegantLayout } from "./charity-elegant";
import { HousewarmingLayout } from "./housewarming";
import { SunriseLayout } from "./sunrise";
import { MilestoneBirthdayLayout } from "./milestone-birthday";
import { LoversLayout } from "./lovers";
import { IftarLayout } from "./iftar";
// 5 layouts (round 4 — wedding maximalist)
import { BaroqueGoldLayout } from "./baroque-gold";
import { TulipMiniatureLayout } from "./tulip-miniature";
import { CelestialFoilLayout } from "./celestial-foil";
import { GardenCascadeLayout } from "./garden-cascade";
import { BukharaRoyalLayout } from "./bukhara-royal";
// 5 layouts (round 5 — birthday maximalist)
import { KidCarnivalLayout } from "./kid-carnival";
import { PrincessCastleLayout } from "./princess-castle";
import { SparklerMilestoneLayout } from "./sparkler-milestone";
import { VintageFairLayout } from "./vintage-fair";
import { DiscoNeonLayout } from "./disco-neon";
// User-imported standalone HTML templates
import { DiyoraPreviewLayout } from "./diyora-preview";
import { AvgustPreviewLayout } from "./avgust-preview";
import { SentabrPreviewLayout } from "./sentabr-preview";
// Round 6 — 10 mobile-first iframe-static wedding templates
import { MehrliPreviewLayout } from "./mehrli-preview";
import { TilakliPreviewLayout } from "./tilakli-preview";
import { OlovgulPreviewLayout } from "./olovgul-preview";
import { BezakliPreviewLayout } from "./bezakli-preview";
import { IpakliPreviewLayout } from "./ipakli-preview";
import { SokinPreviewLayout } from "./sokin-preview";
import { MavjliPreviewLayout } from "./mavjli-preview";
import { LavandaPreviewLayout } from "./lavanda-preview";
import { OlchaPreviewLayout } from "./olcha-preview";
import { QuyoshliPreviewLayout } from "./quyoshli-preview";
import { BeshikToyiPreviewLayout } from "./beshik-toyi-preview";
// Round 7 — 5 mixed iframe-static templates (corporate yubiley,
// romantic date-ask, soft-bloom birthday, two new wedding showcases)
import { YubileyKorporativPreviewLayout } from "./yubiley-korporativ-preview";
import { UchrashuvPreviewLayout } from "./uchrashuv-preview";
import { BarakaliPreviewLayout } from "./barakali-preview";
import { AlisherMuazzamPreviewLayout } from "./alisher-muazzam-preview";
import { AnvarMasumaPreviewLayout } from "./anvar-masuma-preview";
// Round 8 — 4 designer iframe-static templates (Risograph birthday,
// editorial corporate quarterly, romantic one-question ask, cinema-
// frame editorial wedding)
import { BirthdayRisoPreviewLayout } from "./birthday-riso-preview";
import { CorporateQuarterlyPreviewLayout } from "./corporate-quarterly-preview";
import { MarryMeOneQuestionPreviewLayout } from "./marry-me-one-question-preview";
import { WeddingEditorialCinemaPreviewLayout } from "./wedding-editorial-cinema-preview";
// Round 9 — 25 bookie-style templates (premium category)
import { BookiePaperGoldPreviewLayout } from "./bookie-paper-gold-preview";
import { BookieSagePreviewLayout } from "./bookie-sage-preview";
import { BookieWinePreviewLayout } from "./bookie-wine-preview";
import { BookieTealPreviewLayout } from "./bookie-teal-preview";
import { BookieMidnightPreviewLayout } from "./bookie-midnight-preview";
import { BookieCopperPreviewLayout } from "./bookie-copper-preview";
import { BookieMauvePreviewLayout } from "./bookie-mauve-preview";
import { BookieEmeraldPreviewLayout } from "./bookie-emerald-preview";
import { BookieBlushPreviewLayout } from "./bookie-blush-preview";
import { BookieNavyPreviewLayout } from "./bookie-navy-preview";
import { BookieAmberPreviewLayout } from "./bookie-amber-preview";
import { BookiePearlPreviewLayout } from "./bookie-pearl-preview";
import { BookieTerracottaPreviewLayout } from "./bookie-terracotta-preview";
import { BookieCharcoalPreviewLayout } from "./bookie-charcoal-preview";
import { BookieRosePreviewLayout } from "./bookie-rose-preview";
import { BookieOlivePreviewLayout } from "./bookie-olive-preview";
import { BookieBurgundyPreviewLayout } from "./bookie-burgundy-preview";
import { BookieJadePreviewLayout } from "./bookie-jade-preview";
import { BookieSaffronPreviewLayout } from "./bookie-saffron-preview";
import { BookieOnyxPreviewLayout } from "./bookie-onyx-preview";
import { BookieChampagnePreviewLayout } from "./bookie-champagne-preview";
import { BookieForestPreviewLayout } from "./bookie-forest-preview";
import { BookieCoralPreviewLayout } from "./bookie-coral-preview";
import { BookiePlumPreviewLayout } from "./bookie-plum-preview";
import { BookieAzurePreviewLayout } from "./bookie-azure-preview";
// Round 10 — 2 new designer iframe-static templates
import { NikohPreviewLayout } from "./nikoh-preview";
import { WeddingIsComingPreviewLayout } from "./wedding-is-coming-preview";
// Round 11 — Buklama paper-diorama / tunnel-book template
import { BuklamaPreviewLayout } from "./buklama-preview";
// Round 12 — 2 designer watercolor wedding templates
import { GardenArchPreviewLayout } from "./garden-arch-preview";
import { MountainPreviewLayout } from "./mountain-preview";
// Round 13 — celestial night-sky wedding template
import { StarryNightPreviewLayout } from "./starry-night-preview";
// Round 14 — terracotta dried-floral wedding template
import { TerracottaPreviewLayout } from "./terracotta-preview";
// Round 15 — paper-cut tunnel-book fairy-tale wedding template
import { ErtakPreviewLayout } from "./ertak-preview";
// Round 16 — twilight fairy-tale tunnel-book wedding template
import { PariPreviewLayout } from "./pari-preview";
// Round 17 — kids' circus / carnival birthday template
import { SharlarPreviewLayout } from "./sharlar-preview";
// Round 18 — sweet kids garden-party birthday template
import { AsalariPreviewLayout } from "./asalari-preview";
// Round 19 — celestial-library storybook birthday keepsake
import { RumaysaPreviewLayout } from "./rumaysa-preview";
// Round 20 — autumn-marigold watercolor wedding invitation
import { MarigoldPreviewLayout } from "./marigold-preview";
// Round 21 — peacock-motif emerald nikoh invitation
import { TovusPreviewLayout } from "./tovus-preview";
// Round 22 — midnight-blue & gold "Tungi Saroy" wedding invitation
import { MidnightPalacePreviewLayout } from "./midnight-palace-preview";
// Round 23 — night-to-day "Yomg'irdan so'ng" wedding invitation
import { YomgirPreviewLayout } from "./yomgir-preview";
// Round 24 — sunny-meadow "Yaylov" wedding invitation
import { YaylovPreviewLayout } from "./yaylov-preview";
// Round 25 — sakura-falls "Sakura" wedding invitation
import { SakuraPreviewLayout } from "./sakura-preview";
// Round 26 — book-open "Qog'oz ertagi" storybook wedding invitation
import { QogozPreviewLayout } from "./qogoz-preview";
// Round 27 — railway-journey "Oltin yo'l" wedding invitation
import { OltinYolPreviewLayout } from "./oltin-yol-preview";
// Round 28 — endless-sky "Cheksiz osmon" wedding invitation
import { OsmonPreviewLayout } from "./osmon-preview";
// Round 29 — four-seasons-scroll "To'rt fasl" wedding invitation
import { FasllarPreviewLayout } from "./fasllar-preview";
// Round 30 — wax-seal envelope reveal "Envelope" wedding invitation
import { EnvelopePreviewLayout } from "./envelope-preview";

export type { LayoutCtx } from "./_shared";

export const LAYOUTS: Record<string, (ctx: LayoutCtx) => JSX.Element> = {
  "photo-bleed": PhotoBleedLayout,
  "noir-gold": NoirGoldLayout,
  "watercolor": WatercolorLayout,
  "arch-photo": ArchPhotoLayout,
  "modernist": ModernistLayout,
  "playful": PlayfulLayout,
  "soft-pastel": SoftPastelLayout,
  "corporate-grid": CorporateGridLayout,
  "memorial-frame": MemorialFrameLayout,
  // 10 layouts (round 2)
  "miniature": MiniatureLayout,
  "coastal": CoastalLayout,
  "milestone": MilestoneLayout,
  "rose-gold": RoseGoldLayout,
  "suzani-burst": SuzaniBurstLayout,
  "scroll-academic": ScrollAcademicLayout,
  "champagne": ChampagneLayout,
  "neon-tech": NeonTechLayout,
  "geometric-mosaic": GeometricMosaicLayout,
  "hospitality": HospitalityLayout,
  // 10 layouts (round 3)
  "corp-anniversary": CorpAnniversaryLayout,
  "retail-opening": RetailOpeningLayout,
  "conf-tracks": ConfTracksLayout,
  "masterclass": MasterclassLayout,
  "charity-elegant": CharityElegantLayout,
  "housewarming": HousewarmingLayout,
  "sunrise": SunriseLayout,
  "milestone-birthday": MilestoneBirthdayLayout,
  "lovers": LoversLayout,
  "iftar": IftarLayout,
  // 5 layouts (round 4 — wedding maximalist)
  "baroque-gold": BaroqueGoldLayout,
  "tulip-miniature": TulipMiniatureLayout,
  "celestial-foil": CelestialFoilLayout,
  "garden-cascade": GardenCascadeLayout,
  "bukhara-royal": BukharaRoyalLayout,
  // 5 layouts (round 5 — birthday maximalist)
  "kid-carnival": KidCarnivalLayout,
  "princess-castle": PrincessCastleLayout,
  "sparkler-milestone": SparklerMilestoneLayout,
  "vintage-fair": VintageFairLayout,
  "disco-neon": DiscoNeonLayout,
  // User-imported standalone HTML templates
  "diyora-preview": DiyoraPreviewLayout,
  "avgust-preview": AvgustPreviewLayout,
  "sentabr-preview": SentabrPreviewLayout,
  // Round 6 — 10 mobile-first iframe-static wedding templates
  "mehrli-preview": MehrliPreviewLayout,
  "tilakli-preview": TilakliPreviewLayout,
  "olovgul-preview": OlovgulPreviewLayout,
  "bezakli-preview": BezakliPreviewLayout,
  "ipakli-preview": IpakliPreviewLayout,
  "sokin-preview": SokinPreviewLayout,
  "mavjli-preview": MavjliPreviewLayout,
  "lavanda-preview": LavandaPreviewLayout,
  "olcha-preview": OlchaPreviewLayout,
  "quyoshli-preview": QuyoshliPreviewLayout,
  "beshik-toyi-preview": BeshikToyiPreviewLayout,
  // Round 7 — 5 mixed iframe-static templates
  "yubiley-korporativ-preview": YubileyKorporativPreviewLayout,
  "uchrashuv-preview": UchrashuvPreviewLayout,
  "barakali-preview": BarakaliPreviewLayout,
  "alisher-muazzam-preview": AlisherMuazzamPreviewLayout,
  "anvar-masuma-preview": AnvarMasumaPreviewLayout,
  // Round 8 — 4 designer iframe-static templates
  "birthday-riso-preview": BirthdayRisoPreviewLayout,
  "corporate-quarterly-preview": CorporateQuarterlyPreviewLayout,
  "marry-me-one-question-preview": MarryMeOneQuestionPreviewLayout,
  "wedding-editorial-cinema-preview": WeddingEditorialCinemaPreviewLayout,
  // Round 9 — 25 bookie-style templates (premium category)
  "bookie-paper-gold-preview": BookiePaperGoldPreviewLayout,
  "bookie-sage-preview": BookieSagePreviewLayout,
  "bookie-wine-preview": BookieWinePreviewLayout,
  "bookie-teal-preview": BookieTealPreviewLayout,
  "bookie-midnight-preview": BookieMidnightPreviewLayout,
  "bookie-copper-preview": BookieCopperPreviewLayout,
  "bookie-mauve-preview": BookieMauvePreviewLayout,
  "bookie-emerald-preview": BookieEmeraldPreviewLayout,
  "bookie-blush-preview": BookieBlushPreviewLayout,
  "bookie-navy-preview": BookieNavyPreviewLayout,
  "bookie-amber-preview": BookieAmberPreviewLayout,
  "bookie-pearl-preview": BookiePearlPreviewLayout,
  "bookie-terracotta-preview": BookieTerracottaPreviewLayout,
  "bookie-charcoal-preview": BookieCharcoalPreviewLayout,
  "bookie-rose-preview": BookieRosePreviewLayout,
  "bookie-olive-preview": BookieOlivePreviewLayout,
  "bookie-burgundy-preview": BookieBurgundyPreviewLayout,
  "bookie-jade-preview": BookieJadePreviewLayout,
  "bookie-saffron-preview": BookieSaffronPreviewLayout,
  "bookie-onyx-preview": BookieOnyxPreviewLayout,
  "bookie-champagne-preview": BookieChampagnePreviewLayout,
  "bookie-forest-preview": BookieForestPreviewLayout,
  "bookie-coral-preview": BookieCoralPreviewLayout,
  "bookie-plum-preview": BookiePlumPreviewLayout,
  "bookie-azure-preview": BookieAzurePreviewLayout,
  // Round 10 — 2 new designer iframe-static templates
  "nikoh-preview": NikohPreviewLayout,
  "wedding-is-coming-preview": WeddingIsComingPreviewLayout,
  // Round 11 — Buklama paper-diorama / tunnel-book template
  "buklama-preview": BuklamaPreviewLayout,
  // Round 12 — 2 designer watercolor wedding templates
  "garden-arch-preview": GardenArchPreviewLayout,
  "mountain-preview": MountainPreviewLayout,
  // Round 13 — celestial night-sky wedding template
  "starry-night-preview": StarryNightPreviewLayout,
  // Round 14 — terracotta dried-floral wedding template
  "terracotta-preview": TerracottaPreviewLayout,
  // Round 15 — paper-cut tunnel-book fairy-tale wedding template
  "ertak-preview": ErtakPreviewLayout,
  // Round 16 — twilight fairy-tale tunnel-book wedding template
  "pari-preview": PariPreviewLayout,
  // Round 17 — kids' circus / carnival birthday template
  "sharlar-preview": SharlarPreviewLayout,
  // Round 18 — sweet kids garden-party birthday template
  "asalari-preview": AsalariPreviewLayout,
  // Round 19 — celestial-library storybook birthday keepsake
  "rumaysa-preview": RumaysaPreviewLayout,
  // Round 20 — autumn-marigold watercolor wedding invitation
  "marigold-preview": MarigoldPreviewLayout,
  // Round 21 — peacock-motif emerald nikoh invitation
  "tovus-preview": TovusPreviewLayout,
  // Round 22 — midnight-blue & gold "Tungi Saroy" wedding invitation
  "midnight-palace-preview": MidnightPalacePreviewLayout,
  // Round 23 — night-to-day "Yomg'irdan so'ng" wedding invitation
  "yomgir-preview": YomgirPreviewLayout,
  // Round 24 — sunny-meadow "Yaylov" wedding invitation
  "yaylov-preview": YaylovPreviewLayout,
  // Round 25 — sakura-falls "Sakura" wedding invitation
  "sakura-preview": SakuraPreviewLayout,
  // Round 26 — book-open "Qog'oz ertagi" storybook wedding invitation
  "qogoz-preview": QogozPreviewLayout,
  // Round 27 — railway-journey "Oltin yo'l" wedding invitation
  "oltin-yol-preview": OltinYolPreviewLayout,
  "osmon-preview": OsmonPreviewLayout,
  // Round 29 — four-seasons-scroll "To'rt fasl" wedding invitation
  "fasllar-preview": FasllarPreviewLayout,
  // Round 30 — wax-seal envelope reveal "Envelope" wedding invitation
  "envelope-preview": EnvelopePreviewLayout,
};
